import type { ReactNode } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import type { AppRouteContext } from '../../../app/routeContext';
import { getDeploySurface, getWrongAppInfo } from '../../../lib/deploySurface';
import WrongAppScreen from './WrongAppScreen';

type SurfaceRoleGateProps = {
  children?: ReactNode;
};

/** Blocks authenticated users whose role does not belong on this deploy surface. */
export default function SurfaceRoleGate({ children }: SurfaceRoleGateProps) {
  const context = useOutletContext<AppRouteContext>();
  const surface = getDeploySurface();
  const role = context.core.currentUser?.role;
  const wrongApp = role ? getWrongAppInfo(role, surface) : null;

  if (wrongApp) {
    return (
      <WrongAppScreen
        info={wrongApp}
        onSignOut={() => {
          void context.core.logout?.();
        }}
      />
    );
  }

  return children ? <>{children}</> : <Outlet context={context} />;
}
